import React, { useState, useEffect, useContext } from "react";

import {
  Alert,
  Button,
  Icon,
  Modal,
  ModalBody,
  ModalHeader,
  Nav,
  NavItem,
  NavLink,
  Select,
  Spinner,
  TabContent,
  TabPane,
  Table,
} from "design-react-kit";

import { sendApiRequest } from "../../services/Base/base-service";
import UserContext from "../../store/user-context";
import { useSignIn, useSignOut } from "react-auth-kit";
import { useNavigate, useParams } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";
import DocumentTypeEnum from "../../helpers/Enums/DocumentTypeEnum";

const PreviewModal = () => {
  const params = useParams();
  const clientId = params.clientId;
  const documentTypeId = params?.documentTypeId;

  const [isOpen, toggleModal] = useState(false);
  const [analyzedFiles, setAnalyzedFiles] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [activeTab, setActiveTab] = useState(
    Number.parseInt(documentTypeId) !== DocumentTypeEnum.F24
      ? "key-value"
      : "text"
  );
  const [results, setResults] = useState(null);
  const [value, setValue] = useState(null);

  const userContext = useContext(UserContext);

  const signIn = useSignIn();
  const signOut = useSignOut();
  const navigate = useNavigate();

  useEffect(() => {
    const tabs = document.querySelectorAll(".nav.nav-tabs .nav-item a.active");
    tabs[0]?.classList.add("active-tab");
  }, []);

  useEffect(() => {
    if (isOpen) {
      getAllAnalyzedFilesHandler(clientId);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);

  const toggleTab = (e, tab) => {
    e.preventDefault();
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
    const tabs = document.querySelectorAll(".nav.nav-tabs .nav-item a.active");
    tabs.forEach((tab) => tab.classList.remove("active-tab"));
    e.target.classList.add("active-tab");
  };

  const getAllAnalyzedFilesHandler = (clientId) => {
    setIsLoading(true);
    sendApiRequest(
      `DocumentAnalysis/GetAllAnalyzedFiles?clientId=${clientId}&documentType=${documentTypeId}`,
      "GET",
      true,
      null,
      signIn,
      signOut,
      navigate,
      null,
      userContext
    ).then((response) => {
      if (response !== undefined) {
        if (response.errors !== null) {
          setError(response.errors);
          setIsLoading(false);
        } else {
          const files = [];
          response.data.awsFileAnalysisResults.forEach((file) => {
            files.push({ value: file.fileResultId, label: file.fileName });
          });
          setAnalyzedFiles(files);
          setIsLoading(false);
          const lastPreviewResultId = secureLocalStorage.getItem(
            "lastPreviewResultId"
          );
          const lastPreviewResultName = secureLocalStorage.getItem(
            "lastPreviewResultName"
          );

          if (
            lastPreviewResultId !== null &&
            lastPreviewResultId !== undefined &&
            lastPreviewResultName !== null &&
            lastPreviewResultName !== undefined
          ) {
            setValue({
              value: lastPreviewResultId,
              label: lastPreviewResultName,
            });
            getFileAnalysisResultHandler(lastPreviewResultId);
          } else {
            if (response.data.awsFileAnalysisResults.length > 0) {
              setValue({
                value: response.data.awsFileAnalysisResults[0].fileResultId,
                label: response.data.awsFileAnalysisResults[0].fileName,
              });
              getFileAnalysisResultHandler(
                response.data.awsFileAnalysisResults[0].fileResultId
              );
            }
          }
        }
      }
    });
  };

  const getFileAnalysisResultHandler = (fileResultId) => {
    setIsLoading(true);
    sendApiRequest(
      `DocumentAnalysis/GetFileAnalysisResult?fileResultId=${fileResultId}`,
      "GET",
      true,
      null,
      signIn,
      signOut,
      navigate,
      null,
      userContext
    ).then((response) => {
      if (response !== undefined) {
        if (response.errors !== null) {
          setError(response.errors);
          setIsLoading(false);
        } else {
          setResults({
            ...response.data,
            jsonKeyValuePairs:
              response.data.jsonKeyValuePairs !== ""
                ? JSON.parse(response.data.jsonKeyValuePairs)
                : "",
          });
          setIsLoading(false);
        }
      }
    });
  };

  const handleChange = (selectedOption) => {
    secureLocalStorage.setItem("lastPreviewResultId", selectedOption.value);
    secureLocalStorage.setItem("lastPreviewResultName", selectedOption.label);
    getFileAnalysisResultHandler(selectedOption.value);
    setValue(selectedOption);
  };

  return (
    <div>
      <Button
        color="primary"
        className="mr-3 rounded-0"
        style={{ padding: "10px 10px" }}
        onClick={() => toggleModal(!isOpen)}
      >
        <Icon icon="it-folder" fill="#fff" className="mr-2" />
        Risultati analisi
      </Button>
      <Modal
        isOpen={isOpen}
        toggle={() => toggleModal(!isOpen)}
        align="right"
        labelledBy="preview"
        id="results-modal"
      >
        <ModalHeader
          toggle={() => toggleModal(!isOpen)}
          id="preview"
        ></ModalHeader>
        <ModalBody style={{ maxWidth: "100%", minWidth: "30vw" }}>
          {error !== null && error.length !== undefined && (
            <Alert color="danger" className="mx-auto">
              {error.map((item) => (
                <p key={item}>{item}</p>
              ))}
            </Alert>
          )}
          {isLoading && <Spinner double active />}
          <div className="bootstrap-select-wrapper mt-3">
            <label htmlFor="filesForAnalysis">
              Elenco files già analizzati:
            </label>
            <Select
              id="filesForAnalysis"
              onChange={handleChange}
              value={value}
              //Nessun file selezionato
              options={analyzedFiles}
              placeholder="Seleziona file"
              aria-label="Seleziona file"
            />
          </div>
          {results !== null && results !== undefined && (
            <div className="tabs-wrapper-modal">
              <Nav tabs>
                {Number.parseInt(documentTypeId) !== DocumentTypeEnum.F24 && (
                  <NavItem>
                    <NavLink
                      className="btn"
                      active={activeTab === "key-value"}
                      onClick={(e) => toggleTab(e, "key-value")}
                    >
                      Fonte da chiavi/valore
                    </NavLink>
                  </NavItem>
                )}
                <NavItem>
                  <NavLink
                    className="btn"
                    active={activeTab === "text"}
                    onClick={(e) => toggleTab(e, "text")}
                  >
                    Fonte testuale
                  </NavLink>
                </NavItem>
              </Nav>
              <TabContent activeTab={activeTab}>
                {Number.parseInt(documentTypeId) !== DocumentTypeEnum.F24 && (
                  <TabPane tabId="key-value" key="key-value">
                    <Table bordered className="pr-3 mt-4">
                      <thead>
                        <th>Chiave</th>
                        <th>Valore</th>
                      </thead>
                      <tbody>
                        {Object.keys(results.jsonKeyValuePairs).map((key) => {
                          return (
                            <tr>
                              <td>{results.jsonKeyValuePairs[key].Key} </td>
                              <td>{results.jsonKeyValuePairs[key].Value}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </Table>
                  </TabPane>
                )}
                <TabPane tabId="text" key="text">
                  <textarea
                    className="mt-4"
                    cols={10}
                    rows={50}
                    value={results.contentText}
                  ></textarea>
                </TabPane>
              </TabContent>
            </div>
          )}
          {(results === null || results === undefined) && (
            <p>Nessun risultato trovato!</p>
          )}
        </ModalBody>
      </Modal>
    </div>
  );
};

export default PreviewModal;
